/**
 * ImportGroupNode — collapsible group container for grouped import graph view.
 * Issue #565 Phase 1.
 * Rendered by React Flow as a parent node; file nodes are nested via parentId.
 */

import type { NodeProps } from '@xyflow/react';

function ImportGroupNodeComponent({ data, selected }: NodeProps) {
  const groupKey = data.groupKey as string;
  const memberCount = data.memberCount as number;
  const isCollapsed = data.isCollapsed as boolean;
  const onToggle = data.onToggle as ((groupId: string) => void) | undefined;
  const groupId = data.groupId as string;

  return (
    <div
      className={`rounded-xl border-2 transition-all h-full w-full ${
        selected ? 'border-blue-500 shadow-lg' : 'border-slate-300'
      }`}
      style={{ backgroundColor: 'rgba(248, 250, 252, 0.7)', minWidth: 160 }}
    >
      {/* Group header */}
      <button
        className="w-full flex items-center gap-2 px-3 py-2 bg-slate-100/90 rounded-t-xl border-b border-slate-200 cursor-pointer select-none hover:bg-slate-200/80 transition-colors"
        onClick={() => onToggle?.(groupId)}
        title={isCollapsed ? 'Expand group' : 'Collapse group'}
      >
        <span className="text-xs font-semibold text-slate-700 flex-1 truncate text-left" title={groupKey}>
          {groupKey}
        </span>
        <span className="text-xs text-slate-500 flex-shrink-0">{memberCount}</span>
        <span className="text-slate-400 text-xs flex-shrink-0">{isCollapsed ? '▶' : '▼'}</span>
      </button>
      {/* When collapsed, show a summary inside the container */}
      {isCollapsed && (
        <div className="px-3 py-2 text-xs text-slate-400 italic">
          {memberCount} file{memberCount !== 1 ? 's' : ''} hidden
        </div>
      )}
    </div>
  );
}

export const importGroupNodeTypes = {
  importGroupNode: ImportGroupNodeComponent,
};
